// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__23bcC","left":"StickyBox_left__3W48q","right":"StickyBox_right__UBCmy"};